import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import UIContainer from 'components/UIContainer';
import { useParams, Redirect } from 'react-router';
import styled from 'styled-components';
import { useMyHealthStore } from 'store/mobx/mobx';
import { DocumentDetailSection } from './DocumentDetailSection';
import { actions } from 'components/UIContainer/MobileUI/MainShell/actions/actions';
import moment from 'moment';
import { go } from 'routes';
import { useDispatch } from 'react-redux';
import Loading from 'components/loadingSpinner';

const Background = styled.div`
    background-color: #F5F5F5;
    position: absolute;
    height: 100%;
    width: 100%;
    transition: all 0.3s linear;
    z-index: 10;
    visibility: visible;
`
const DocumentPage: React.FC = observer(() => {
  const { id } = useParams<{ id: string }>();
  const phrStore = useMyHealthStore();
  
  const dispatch = useDispatch();

  useEffect(() => {
    if (phrStore.currentLabPage) {
      if (phrStore.currentLabPage.NeedFeedBackForLabResearch) {
        dispatch(actions.setWhiteBoxNotification({
          isOpen: true,
          index: 4
        }))
      }
    }
  })

  let itemToShow = phrStore.patientDocumentTab.all.find(item => item.Id === id);
  if (!id || !itemToShow) {
    if (phrStore.currentDocumentPage === undefined) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let documentId = params.get('d');

      if (documentId === null) {
        return <Redirect to={"/home"} />
      }

    } else {
      itemToShow = phrStore.currentDocumentPage;
    }
  }
  const getDate = (dateTime: string) => moment(dateTime).format('D/MM/YY');
  if (itemToShow === undefined) {
    return (
      <div>
        <Background />   
        <Loading isFetching={true} style={{position: "absolute", top: "6rem"}} />
      </div>
    )
  }else {
    phrStore.setCurrentDocumentPage(itemToShow);
    const rtfData = itemToShow.Content?.find(d => d.ContentType === "application/rtf")?.Data ?? "";
    return (
      <UIContainer heading=" " phrText={"Received on " + getDate(itemToShow.DateTime)} isFetching={false} goBackFn={() => go.home(3)}>
        <div style={{height: "calc(100vh - 115px)"}}>
          {!itemToShow ? <Loading isFetching={phrStore.loading}/> :
          <DocumentDetailSection
            patientId={itemToShow.PatientId}
            documentId={itemToShow.Id}
            providerName={itemToShow.ProviderName}
            itemName={itemToShow.Description}
            givenName={itemToShow.GivenName}
            familyName={itemToShow.FamilyName}
            organisationName={itemToShow.OrganisationName}
            textContent={rtfData}
            isPDF={itemToShow.Content?.find(d => d.ContentType === "application/pdf") !== undefined}
            hasUrl={itemToShow.Content?.find(d => d.Url && d.Url.trim() !== "")?.Url !== undefined}
          />
          }
      </div>
      </UIContainer>
    );
  }
});

export default DocumentPage;
